import React from 'react';

import { Button, Col, Row, Typography } from 'antd';

import ComponentBlocker from '@src/components/ComponentBlocker';
import { ALLOWED_ROLES } from '@src/packages/utils';
import { WORK_JOURNEY_STATUS } from '@src/packages/workJourney/constants';
import { useWorkJourneyContext } from '@src/packages/workJourney/contexts';
import IntlMessages from '@src/util/IntlMessages';

import styles from '../../../styles.module.less';

const { Paragraph } = Typography;

interface JourneyStateSelectorProps {
  action?: 'create' | 'update';
}

/**
 * @description Component to select the journey state (active/inactive)
 */
const JourneyStateSelector = ({ action = 'create' }: JourneyStateSelectorProps) => {
  const { workJourneyForm, toggleModalVisibility, setWorkJourneyForm } = useWorkJourneyContext();
  const { state } = workJourneyForm;

  const handleStateChange = () => {
    const isActive = state === WORK_JOURNEY_STATUS.ACTIVE;

    if (action === 'create') {
      setWorkJourneyForm({
        ...workJourneyForm,
        state: isActive ? 'inactive' : 'active',
      });
    } else if (action === 'update') {
      if (isActive) toggleModalVisibility('deactivateModal');
      else toggleModalVisibility('activateModal');
    }
  };

  const disabled =
    state === WORK_JOURNEY_STATUS.UPDATED || state === WORK_JOURNEY_STATUS.PENDING;

  return (
    <>
      <Row className={styles.formSectionRow}>
        <Col xs={24} sm={24} md={24} lg={16} xl={16}>
          <Paragraph className={styles.descriptionText}>
            <IntlMessages id="workJourney.stateDescription" />
          </Paragraph>
        </Col>
      </Row>

      <Row className={styles.formSectionRow}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <ComponentBlocker allowedRoles={ALLOWED_ROLES.ORGANIZATIONS.WORK_JOURNEY.UPDATE}>
            <Button type="primary" onClick={handleStateChange} disabled={disabled}>
              {state === WORK_JOURNEY_STATUS.ACTIVE && (
                <IntlMessages id="workJourney.button.deactivate" />
              )}
              {state === WORK_JOURNEY_STATUS.INACTIVE && (
                <IntlMessages id="workJourney.button.activate" />
              )}
              {state === WORK_JOURNEY_STATUS.UPDATED && (
                <IntlMessages id="workJourney.button.cannotChangeState" />
              )}
              {state === WORK_JOURNEY_STATUS.PENDING && (
                <IntlMessages id="workJourney.button.cannotChangeState" />
              )}
            </Button>
          </ComponentBlocker>
        </Col>
      </Row>
    </>
  );
};

export default JourneyStateSelector;
